import { styled } from '@mui/material';

export const Square = styled('div', { name: 'CardsSquare' })({
  aspectRatio: '1 / 1',
  width: '100%',
  height: 0,
  paddingBottom: '100%',
  position: 'relative',
});
